// Badge indicando a origem do exame no carrinho: reconhecido no pedido médico
// (lido pela IA), associado manualmente a um pedido médico (usuário indicou
// que o exame consta no pedido, mas a IA não leu), não oferecido (lido no
// pedido mas fora do catálogo), ou avulso — 2 linhas, cor indica status.
// `orderCount` = quantos pedidos médicos citam esse exame.
export default function SourceTag({ variant, orderCount = 0 }) {
  if (variant === 'recognized') {
    return (
      <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', lineHeight: 1.15, flexShrink: 0 }}>
        <span style={{ fontSize: 8.5, color: 'var(--text-subtle)', textTransform: 'uppercase', letterSpacing: '0.03em' }}>
          Pedido médico{orderCount > 1 ? ` ×${orderCount}` : ''}
        </span>
        <span style={{ fontSize: 11, fontWeight: 700, color: 'var(--success)' }}>Reconhecido</span>
      </span>
    );
  }
  if (variant === 'associated') {
    return (
      <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', lineHeight: 1.15, flexShrink: 0 }}>
        <span style={{ fontSize: 8.5, color: 'var(--text-subtle)', textTransform: 'uppercase', letterSpacing: '0.03em' }}>
          Pedido médico{orderCount > 1 ? ` ×${orderCount}` : ''}
        </span>
        <span style={{ fontSize: 11, fontWeight: 700, color: 'var(--marble)' }}>Adicionado por você</span>
      </span>
    );
  }
  if (variant === 'unrecognized') {
    return (
      <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', lineHeight: 1.15, flexShrink: 0 }}>
        <span style={{ fontSize: 8.5, color: 'var(--text-subtle)', textTransform: 'uppercase', letterSpacing: '0.03em' }}>Pedido médico</span>
        <span style={{ fontSize: 11, fontWeight: 700, color: 'var(--danger)' }}>Não oferecido</span>
      </span>
    );
  }
  return (
    <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', lineHeight: 1.15, flexShrink: 0 }}>
      <span style={{ fontSize: 8.5, color: 'var(--text-subtle)', textTransform: 'uppercase', letterSpacing: '0.03em' }}>Compra</span>
      <span style={{ fontSize: 11, fontWeight: 700, color: 'var(--marble)' }}>Avulso</span>
    </span>
  );
}
